import * as a from '@mitranim/js/all.mjs'
import * as dr from '@mitranim/js/dom_reg.mjs'
import * as u from './util.mjs'
import * as efft from './elem-form-field-text.mjs'

export class FormFieldCents extends efft.FormFieldText {
  static {dr.reg(this)}
  get Input() {return FormFieldCentsInput}
}

/*
Text input that translates between cents and units. The abstract value is cents,
which must be an integer. The DOM value is units, which may be fractional to 2
decimal places. When submitting a form, the value must be obtained by calling
`.getValue` or `.addFormValue`. This is done automatically by our class `Form`.
Forms must ignore the native DOM value of this element.
*/
export class FormFieldCentsInput extends efft.FormFieldInput {
  static {dr.reg(this)}

  initFromSpec(src) {
    return super.initFromSpec(src).setValue(src.value)
  }

  getValue() {
    return u.moneyUnitsToCents(this.getValueAsNumber())
  }

  setValue(val) {
    this.replaceAll(a.renderLax(u.moneyCentsToUnits(val)))
    return this
  }

  // Override for `MixInput..addFormValue`.
  // Invoked by `Form` when building form body for JSON.
  addFormValue(tar) {
    a.reqDict(tar)
    const name = this.name
    if (!a.optStr(name)) return
    tar[name] = u.moneyUnitsToCents(this.getValueAsNumber() ?? null)
  }
}
